import {FlexAlign, FlexGap, StackHorizontal, ToggleSwitch, ToggleType} from "@twigsby/frontend-framework";
import React, {useState} from "react";
import {BatchYesNoType} from "../../../Types/ForwardingBatchTypes";

const BatchYesNo = (props: BatchYesNoType) => {
    const [ notes, setNotes ] = useState<string>(props.notes as string);
    const [ checked, setChecked ] = useState<boolean>(props.isChecked as boolean);

    const HandleChange = (checked: boolean, notes: string) => {
        setChecked(checked);

        if(!props.checkOnly) {
            if(checked && notes && notes !== '') {
                props.onChange({
                    id: props.id,
                    checked: checked,
                    notes: notes,
                })
            }

            if(!checked) {
                props.onChange({
                    id: props.id,
                    checked: checked,
                    notes: notes,
                })
            }
        } else {
            props.onChange({
                id: props.id,
                checked: checked,
            })
        }
    }

    return (
        <StackHorizontal gap={FlexGap.Small}>
            <div className={'flex-row align-center'}  style={{ width: '70%'}}>
                <div style={{width: '70%'}}>{props.label}</div>
                <StackHorizontal gap={FlexGap.Small} align={FlexAlign.Center}>
                    <ToggleSwitch name={props.groupName} label={props.affirmativeLabel || 'Yes'} disabled={props.readOnly} type={ToggleType.Radio} defaultChecked={checked} onChange={() => HandleChange(true, notes)} />
                    <ToggleSwitch name={props.groupName} label={props.negativeLabel || 'No'} disabled={props.readOnly} type={ToggleType.Radio} defaultChecked={!checked} onChange={() => HandleChange(false, notes)} />
                </StackHorizontal>
            </div>

            {!props.checkOnly && checked && (
                <div className={`ml-a ${!notes || notes === '' ? 'invalid' : ''}`}>
                    <textarea
                        placeholder={props.notes}
                        rows={1}
                        onChange={(e) => setNotes(e.currentTarget.value)}
                        onBlur={(e) => {
                            HandleChange(checked, e.currentTarget.value)
                        }}
                        disabled={props.readOnly}
                        defaultValue={props.notes}
                    />
                </div>
            )}
        </StackHorizontal>
    )
}

export { BatchYesNo }
